import type { App } from 'vue';
import { createRouter, createWebHistory } from 'vue-router';
import generatedRoutes from 'virtual:generated-pages';
import { setupLayouts } from 'virtual:generated-layouts';
import { cancelQueue } from '@libs/http';

import { cancelAllEvents } from '@/composables/event/eventBus';

const routes = setupLayouts(generatedRoutes);
const router = createRouter({
  history: createWebHistory(),
  routes,
});

// Flush pending requests upon each route enter
router.beforeEach((to, from, next) => {
  // TODO: check side effects and choose better solution
  if (to.path !== from.path) {
    cancelAllEvents();
  }

  cancelQueue.clearAll();

  next();
});

const install = (Vue: App) => {
  Vue.use(router);
};

export { router, install };
